import { Box, Text } from '@stitch-fix/mode-react';
import styles from './style.module.scss';

export type PageHeadingProps = {
  title: string;
  content: string;
};

export const PageHeading = ({ title, content }: PageHeadingProps) => (
  <Box
    p="3.5rem 1.5rem 2.5rem"
    style={{ textAlign: 'center' }}
    bgColor="gray-95"
  >
    <Text mb={0.5} as="h2" setting="title-xlarge">
      {title}
    </Text>
    <Box maxWidth={30} m="0 auto">
      <Text setting="body-large-fixed">{content}</Text>
    </Box>
    <Box mt={2}>
      {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
      <a href="#below-the-fold" className={styles.arrow} aria-hidden="true" />
    </Box>
    <Box id="below-the-fold" className={styles['below-the-fold']} />
  </Box>
);
